'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type {
  ProcessNavGroup,
  ProcessPreFooterData,
  ProcessSequenceSection,
} from '@/types/process';
import { mapProcessStages } from '../lib/map-process-stages';
import ProcessSection from './ProcessSection';
import ProcessEndSection from './ProcessEndSection';
import ProcessSequenceIntro from './ProcessSequenceIntro';

interface ProcessStagesListProps {
  sequence: ProcessSequenceSection;
  processNav?: ProcessNavGroup | null;
  preFooter?: ProcessPreFooterData | null;
}

export default function ProcessStagesList({
  sequence,
  processNav,
  preFooter,
}: ProcessStagesListProps) {
  const t = useTranslations('ourProces.sequence');
  const stages = useMemo(
    () => mapProcessStages(sequence.steps, processNav, t),
    [sequence.steps, processNav, t],
  );

  if (stages.length === 0) return null;

  return (
    <>
      <ProcessSequenceIntro heading={sequence.heading} descriptionHtml={sequence.descriptionHtml} />

      <div>
        {stages.map((stage) => (
          <div
            key={stage.sectionId}
            id={stage.sectionId}
            data-stage-index={stage.id - 1}
            className="scroll-mt-[var(--site-header-height)]"
          >
            <ProcessSection stage={stage} />
          </div>
        ))}
      </div>

      <ProcessEndSection preFooter={preFooter} />
    </>
  );
}
